import React, { useEffect, useState, useContext } from "react";
import { PriceDisplay } from "./PriceDisplay";


function CreateMissionHeaderAndTitleRow(props) {

    const hidePrice = props.hidePrice ? props.hidePrice : false;
    return (

        <div className="create-mission-header-row">
            <div className="create-mission-header-text-div">
                <div className="create-mission-title">
                    {props.title}
                </div>
                <div className="create-mission-subtitle">
                    {props.subtitle}
                </div>
            </div>
            {!hidePrice && <PriceDisplay price={props.price} totalPrice={props.totalPrice} />}
        </div>

    )
}

export default CreateMissionHeaderAndTitleRow;